const Logo = () => {
    return (
        <div className="flex items-center gap-2">

            <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo/logo.webp`}
                className="
                w-10 
                object-cover
                bg-gradient-to-r
                flex items-center justify-center
                text-white font-bold
                "
                alt=""
            />

            <span className="font-semibold translate-y-1 bg-gradient-to-r from-[#543389] to-[#8b6bd9]
        bg-clip-text text-transparent">
                آکادمی ساراد
            </span>

        </div>
    );
};


export default Logo